import { Skeleton } from "@dafiti/closet-ui";
import { useFormatter, useTranslations } from "next-intl";

type Props = {
  total: number;
  isLoading?: boolean;
};

export function CatalogTotalProducts({ total, isLoading }: Props) {
  const t = useTranslations("catalog");
  const format = useFormatter();

  if (isLoading) {
    return (
      <div className="mt-2">
        <Skeleton className="w-20 h-5 rounded-none" />
      </div>
    );
  }

  const formattedTotalNumber = format.number(total);

  return (
    <div className="mt-2 text-gray-600 text-xs flex gap-1">
      <span className="font-bold">{formattedTotalNumber}</span>

      <span>{t("productsCount", { count: total })}</span>
    </div>
  );
}
